import styled from 'styled-components'

// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-responsive-images
import {
  ProgressiveAsset,
  ResponsiveImageWithSkeletonWrapper,
  fromMd,
  timingDefault,
  untilMd,
} from '@syconium/little-miss-figgy'

import { swiperCSS } from '../../../lib/shared-styles'

const arrowInset = '16px'

const Arrow = styled.button`
  align-items: center;
  background: white;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  height: 40px;
  justify-content: center;
  opacity: 0;
  position: absolute;
  top: 50%;
  transition: opacity ${timingDefault};
  width: 40px;
  -webkit-tap-highlight-color: transparent;

  ${untilMd} {
    &:focus {
      outline: none !important;
    }
  }
`

export const NavigationArrowsWrapper = styled.div`
  position: absolute;
  inset: 0px;
`

export const LeftArrow = styled(Arrow)`
  inset-inline-start: ${arrowInset};
  transform: translateY(-50%);
  z-index: 3;
  &:focus {
    opacity: 1;
  }

  .rtl & {
    transform: scaleX(-1);
  }
`

export const RightArrow = styled(Arrow)`
  inset-inline-end: ${arrowInset};
  transform: translateY(-50%);
  z-index: 3;
  &:focus {
    opacity: 1;
  }

  .rtl & {
    transform: scaleX(-1);
  }
`

export const RootWrapper = styled.div`
  min-width: 0px;
  min-height: 0px;

  ${swiperCSS}

  display: flex;

  .swiper {
    height: 100%;

    ${fromMd} {
      height: fit-content;
      border-radius: ${o => o.theme.spacing(2, 0, 0, 2)};
      &:hover ${Arrow} {
        opacity: 1;
      }
    }

    ${untilMd} {
      ${Arrow} {
        opacity: 1;
      }
    }
  }

  .swiper-wrapper {
    min-height: 0px;
    height: auto;
    max-height: 100%;
    ${untilMd} {
      height: 100%;
    }
  }

  .swiper-slide {
    max-height: 100%;
    width: 100%;
    max-width: 100%;
    position: relative;

    & > div {
      display: block;
    }
  }

  .swiper-pagination {
    ${untilMd} {
      display: none;
    }

    display: flex;
    justify-content: center;
    gap: 8px;

    .swiper-pagination-bullet {
      background-color: ${o => o.theme.color.deprecated.stoneDark};
      height: 4px;
      width: 4px;
    }
    .swiper-pagination-bullet-active {
      background-color: ${o => o.theme.color.deprecated.white.primary};
    }
  }
`

export const GallerySliderWrapper = styled.div`
  position: relative;
  flex-grow: 1;
  flex-shrink: 1;
  min-height: 0px;
  height: fit-content;
  max-height: 100%;
  min-width: 0px;

  ${untilMd} {
    width: 100%;
  }
`

export const GalleryImage = styled(ResponsiveImageWithSkeletonWrapper)``

export const GalleryVideo = styled(ProgressiveAsset.Video)`
  width: 100%;
  max-width: 100%;
  object-fit: contain;
  height: auto;

  ${untilMd} {
    width: 100%;
    min-height: 100%;
  }
`
